import styled from 'styled-components';
import {
  Flex,
  TabType,
  useStickySafeNavigate,
  Tab,
  useCreateAndAddRefs,
  useRefs,
  useHeaderHeight,
  Container,
  TabNavContainer,
  TabButton,
} from '@equifinance/shared';
import { CompanyPageType } from './CompanyTabPage';
import { useCompanyContext } from '../../../contexts/company';
import { useCanAccessBrokerDetails } from '../../BrokerDetails/hooks/useCanAccessBrokerDetails';

type CompanyTabNavProps = {
  page: CompanyPageType,
}

const Wrapper = styled(Flex) <{ top: number }>`
  top:${({ top }) => top}px;
  gap: ${({ theme }) => theme.padding[2]};
  justify-content: space-between;
  position:sticky;
  z-index:3;
  background: ${({ theme }) => theme.colours.neutral[8]};
  padding-bottom: ${({ theme }) => theme.padding[4]};
  padding-top: ${({ theme }) => theme.padding[1]};
`;

export const COMPANY_TAB_NAV = 'company-tab-nav';

export default function CompanyTabNav({ page }: CompanyTabNavProps) {
  const { company: { id: companyId } } = useCompanyContext();
  const canAccessBrokerDetails = useCanAccessBrokerDetails();

  const navigate = useStickySafeNavigate();
  const currentPageTabType = (tabPage: CompanyPageType) => (page === tabPage ? TabType.PRIMARY : TabType.SECONDARY);

  const brokerDetailsTab: Tab = {
    id: CompanyPageType.BROKER_DETAILS,
    tabType: currentPageTabType(CompanyPageType.BROKER_DETAILS),
    label: 'Broker Details',
    percentComplete: undefined,
    onClick: () => navigate(`/broker-details/${companyId}`),
  };

  const manageUserTab: Tab = {
    id: CompanyPageType.MANAGE_USER,
    tabType: currentPageTabType(CompanyPageType.MANAGE_USER),
    label: 'Manage User / API',
    percentComplete: undefined,
    onClick: () => navigate(`/manage-user/${companyId}`),
  };

  const tabs: Tab[] = [
    ...(canAccessBrokerDetails ? [brokerDetailsTab] : []), manageUserTab,
  ];

  const tabNavsRef = useCreateAndAddRefs(COMPANY_TAB_NAV);

  const headerHeight = useHeaderHeight();

  return (
    <Wrapper id={COMPANY_TAB_NAV} ref={tabNavsRef} top={headerHeight}>
      <Container>
        <TabNavContainer>
          {tabs.map((tab) => (
            <TabButton tab={tab} />
          ))}
        </TabNavContainer>
      </Container>
    </Wrapper>
  );
}

export const useCompanyTabNavHeight = () => {
  const { refs } = useRefs();
  const headerHeight = useHeaderHeight();
  return (refs[COMPANY_TAB_NAV]?.current?.clientHeight ?? 0) + headerHeight;
};
